var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorRecorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor-recorder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8334 9.90829V10.65C18.8334 13.6166 18.0917 14.35 15.1334 14.35H5.86675C2.90841 14.35 2.16675 13.6083 2.16675 10.65V5.36663C2.16675 2.40829 2.90841 1.66663 5.86675 1.66663H7.16675",
    stroke: "#5B5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 14.35V18.3333",
    stroke: "#5B5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.16675 10.8334H18.8334",
    stroke: "#5B5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.75 18.3334H14.25",
    stroke: "#5B5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3833 7.80838H11.4166C10.2666 7.80838 9.8833 7.04172 9.8833 6.27505V3.34172C9.8833 2.42505 10.6333 1.67505 11.55 1.67505H15.3833C16.2333 1.67505 16.9166 2.35838 16.9166 3.20838V6.27505C16.9166 7.12505 16.2333 7.80838 15.3833 7.80838Z",
    stroke: "#5B5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.9251 6.60002L16.9167 5.89169V3.59169L17.9251 2.88335C18.4251 2.54169 18.8334 2.75002 18.8334 3.35835V6.13335C18.8334 6.74169 18.4251 6.95002 17.9251 6.60002Z",
    stroke: "#5B5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorRecorder);
export default __webpack_public_path__ + "static/media/monitor-recorder.8b8702bcd27d0335e21f1e41571a9be5.svg";
export { ForwardRef as ReactComponent };